export default "__VITE_ASSET__Dy7O6tjz__"